<template>
  <drop-zone
      class="upload-media"
      :accept="accept"
      @change="handleFileChange"
  >
      <b-overlay :show="loading" rounded="sm" class="w-100">
          <div class="wrapper d-flex flex-column justify-content-center align-items-center">
              <div v-if="value" class="w-100 d-flex justify-content-end mb-1 zindex-4">
                  <a v-if="uploaded" :href="url" :download="url" target="_blank" style="margin-top: -3px">
                      <feather-icon
                          icon="DownloadIcon"
                          class="mr-1"
                      />
                  </a>
                  <feather-icon
                      icon="EyeIcon"
                      class="mr-1"
                      @click.prevent.stop="showFilePreview"
                  />
                  <feather-icon
                      icon="TrashIcon"
                      @click.p.prevent.stop="deleteFile"
                  />
              </div>
              <b-img v-if="type === 'image'" :key="key" :src="preview" alt="file-preview" class="w-100" />
              <video v-if="type === 'video'" :key="key" class="w-100">
                  <source :src="preview" />
              </video>
            <div v-if="type === 'audio'" style="background-color: #989898;border-radius: 15px;padding: 5px;color: white">
              <feather-icon icon="MusicIcon" size="35" />
            </div>
              <div v-if="!value" class="mt-2">
                  <feather-icon :icon="icon || 'FilePlusIcon'" size="20" style="margin-bottom: 10px" />
                  <p
                      class="v-media-placeholder"
                      v-text="label"
                  />
              </div>
          </div>
      </b-overlay>
      <b-modal
          v-model="showPreview"
          ok-title="بستن"
          cancel-variant="outline-info"
          centered
          ok-only
          @ok="showPreview = false"
      >
          <Div class="text-center">
              <b-img
                  v-if="type === 'image'"
                  fluid
                  :src="preview"
              />
              <audio v-if="type === 'audio'" controls>
                  <source :src="preview" id="src" />
              </audio>
              <BEmbed
                  v-if="type === 'video'"
                  type="video"
                  aspect="4by3"
                  controls
              >
                  <source
                      :src="preview"
                      type="video/mp4"
                  >
              </BEmbed>
          </Div>

      </b-modal>
  </drop-zone>
</template>

<script>
import dropZone from './dropZone.vue'
import {BEmbed} from "bootstrap-vue";
export default {
    name: "uploadMedia",
    components: {BEmbed, dropZone },
    props: {
        value: { type: [File, String, Object, Array], default: null },
        loading: { type: Boolean, default: false },
        accept: { type: String, default: '.jpg,.jpeg,.png,.gif' },
        label: { type: String, default: 'انتخاب فایل' },
        icon: { type: String, default: '' }
    },
    data() {
        return {
            uploaded: false,
            showPreview: false,
            preview: '',
            url: '',
            key: ''
        }
    },
    computed: {
        type() {
            return this.fileInfo.type
        },
        fileInfo() {
            if (!this.value || typeof this.value !== 'object') return {}
            let file = this.value
            let name = file.name
            let mimeType = file.type
            let type = mimeType.split('/')[0]
            return { name, type, mimeType }
        }
    },
    watch: {
        value: {
          immediate: true,
          handler(file) {
            if (file !== null)
              this.convertToFile(file)
            else {
              this.preview = ''
              this.url = ''
              this.uploaded = false
            }
          }
        },
    },
    methods: {
        handleFileChange(file) {
            this.uploaded = false
            this.$emit('input', file)

            this.$emit('updated', file)
        },
        showFilePreview() {
            this.showPreview = true
        },
        deleteFile() {
            if (this.uploaded) this.$emit('delete')
            else this.$emit('input', null)
        },
        convertToFile(file) {
            if (typeof this.value === 'object') {
                this.key = Math.floor(Math.random() * 100);
                this.preview = URL.createObjectURL(file)
            }
            else {
                this.url = file
                this.uploaded = true
                this.convertUrlToObject()
            }
        },
        convertUrlToObject() {
            const url = this.value
            const toDataURL = url => fetch(new Request(url))
                .then(response => response.blob())
                .then(blob => new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onloadend = () => resolve(reader.result)
                    reader.onerror = reject
                    reader.readAsDataURL(blob)
                }))

            function dataURLtoFile(dataurl, url) {
                const arr = dataurl.split(',')
                const mime = arr[0].match(/:(.*?);/)[1]
                const bstr = atob(arr[1])
                let n = bstr.length
                const u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], url.split('/').pop(), { type: mime })
            }

            toDataURL(url)
                .then(dataUrl => {
                    const fileData = dataURLtoFile(dataUrl, url)
                    this.$emit('input', fileData)
                })
        },
    }
}
</script>

<style lang="scss">
.upload-media {
    .wrapper {
        padding: 10px 10px 20px 10px;
    }
}
</style>